import React from 'react';
import { Card } from '@cp/ds/src/components/card';
import { Typography } from '@cp/ds/src/components/typography';
import { Divider } from '@cp/ds/src/components/divider';
import { Stack } from '@cp/ds/src/components/stack';
import { styled } from '@cp/ds/src/theme';
import { useTitle } from '@cp/entities/vacancy';
import { useIsMobile } from '@cp/ds/src/hooks';
import { useAddress, useReplies } from '../../model';
import { VacancyCardProps } from './model';
import { Tokens, name } from './const';
import { Parameters } from './parameters';
import { CreatedAt } from './createdAt';
import { Replied } from './replied';
import { Description } from './description';
import { Footer } from './footer';
import { Title } from './title';
import { Address } from './address';
import { Viewed } from './viewed';

const StyledCard = styled(Card, { name, shouldForwardProp: (p) => p !== 'viewed' && p !== 'replied' })<{
  replied?: boolean;
  viewed?: boolean;
}>(({ theme, replied, viewed }) => ({
  borderRadius: '24px',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1.5),
  gap: theme.spacing(0.75),
  ...(viewed && { [Tokens.textColor]: Tokens.viewedColor(theme.palette.gray) }),
  ...(replied && { [Tokens.textColor]: Tokens.repliedColor(theme.palette.gray) }),
}));

export const VacancyCard: React.FC<VacancyCardProps> = ({ width = '100%', viewed, replied, data, url, footer, disableInfo, ...props }) => {
  const title = useTitle(data);
  const isMobile = useIsMobile();
  const replies = useReplies(data);
  const address = useAddress(data, { enableJSX: true });

  const renderedStatus = replied ? <Replied data={data} /> : viewed ? <Viewed data={data} /> : <CreatedAt data={data} sx={{ mb: 0.5 }} />;

  return (
    <StyledCard data-itemid={data.id} replied={replied} viewed={viewed} width={width} {...props}>
      {isMobile && renderedStatus}

      <Stack alignItems="flex-start" direction="row" justifyContent="space-between">
        <Title onClick={props.onTitleClick} url={url}>
          {title}
        </Title>

        {!isMobile && renderedStatus}
      </Stack>
      <Address disableInfo={disableInfo}>{address}</Address>
      <Parameters data={data} />

      <Divider />

      <Description sx={{ filter: disableInfo ? 'blur(7px)' : 'none', pointerEvents: disableInfo ? 'none' : 'all' }}>
        {data.translation?.description ?? ''}
      </Description>
      <Footer>
        {replies ? (
          <Typography sx={{ color: 'gray dark' }} variant="caption">
            {replies}
          </Typography>
        ) : null}
        {footer}
      </Footer>
    </StyledCard>
  );
};
export default VacancyCard;
